import { render, staticRenderFns } from "./cancelled-orders-chart.vue?vue&type=template&id=ddedce02&scoped=true&"
import script from "./cancelled-orders-chart.vue?vue&type=script&lang=js&"
export * from "./cancelled-orders-chart.vue?vue&type=script&lang=js&"
import style0 from "./cancelled-orders-chart.vue?vue&type=style&index=0&id=ddedce02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddedce02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddedce02')) {
      api.createRecord('ddedce02', component.options)
    } else {
      api.reload('ddedce02', component.options)
    }
    module.hot.accept("./cancelled-orders-chart.vue?vue&type=template&id=ddedce02&scoped=true&", function () {
      api.rerender('ddedce02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/monitoring/charts/cancelled-orders-chart.vue"
export default component.exports